import type { OrgNewDraft } from '@/public/features/org/types'
import { CARD_ACCESS_MAX, CARD_SUMMARY_MAX, CARD_TEXT_MAX, CARD_TITLE_MAX } from '@/public/features/org/constants/orgNew'
import { Field, StepHeadLarge } from '@/public/features/org/ui/orgNew/parts'

export function StepCardContent({ draft }: { draft: OrgNewDraft }) {
  return (
    <section className="flex flex-col gap-8">
      <StepHeadLarge
        title="해결카드 만들어 주세요."
        desc="실제로 제공하는 서비스를 작성해 주세요."
      />
      <div className="flex flex-col gap-6">
        <Field
          label="해결카드 이름"
          required
          placeholder=""
          value={draft.cardTitle}
          onChange={(v) => draft.setCardTitle(v.slice(0, CARD_TITLE_MAX))}
        />
        <CardTextarea
          label="한 줄 요약"
          required
          placeholder="예: 정기적인 말벗 활동으로 혼자 지내는 어르신의 외로움을 줄이고 일상 속 정서적 연결을 돕는 프로그램"
          value={draft.cardSummary}
          max={CARD_SUMMARY_MAX}
          showCount
          onChange={draft.setCardSummary}
        />
        <CardTextarea
          label="어떤 문제를 해결하나요?"
          required
          placeholder="예: 혼자 지내는 어르신이 대화할 기회와 사회적 관계가 부족해 외로움과 정서적 고립을 겪고 있습니다."
          value={draft.cardProblem}
          max={CARD_TEXT_MAX}
          onChange={draft.setCardProblem}
        />
        <CardTextarea
          label="어떻게 해결할 수 있나요?"
          required
          placeholder="예: 교육받은 활동가가 어르신과 정기적으로 만나거나 전화로 안부를 묻고 대화를 나누며 지속적인 관계 형성을 지원합니다."
          value={draft.cardBody}
          max={CARD_TEXT_MAX}
          onChange={draft.setCardBody}
        />
        <CardTextarea
          label="운영상 한계 혹은 필수 조건이 있다면 작성해주세요."
          placeholder="예: 평일 낮만 가능, 최소 5명 이상 등"
          value={draft.cardAccess}
          max={CARD_ACCESS_MAX}
          onChange={draft.setCardAccess}
        />
      </div>
    </section>
  )
}
function CardTextarea({
  label,
  placeholder,
  value,
  max,
  showCount = false,
  required = false,
  onChange,
}: {
  label: string
  placeholder: string
  value: string
  max: number
  showCount?: boolean
  required?: boolean
  onChange: (v: string) => void
}) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="flex items-start gap-1 text-body-sm font-normal text-black-600">
        {label}
        {required && <span className="mt-0.5 h-1 w-1 shrink-0 rounded-full bg-[#f54550]" />}
      </span>
      <textarea
        className="h-[260px] w-full resize-none rounded-lg border border-white-400 bg-white-50 px-3.5 py-3.5 font-[inherit] text-body-md text-black-800 placeholder:text-black-100"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, max))}
      />
      {showCount && (
        <span className="flex items-baseline justify-end gap-0.5 text-body-sm">
          <span className="text-violet-600">{value.length}</span>
          <span className="text-black-100">{`/${max}`}</span>
        </span>
      )}
    </label>
  )
}
